import {
  ProviderFilters,
  SearchFilter,
  WbTableFilters,
} from '@agilelab/plugin-wb-platform';
import useDomainContext from './ResourceProvider';

export interface ResourceFilters extends ProviderFilters {}

export const ResourceFiltersSection = () => {
  const { filters, changeFilters, resetFilters, templateKind } =
    useDomainContext();

  const filterElement = (key: string) => {
    if (key === 'search')
      return (
        <SearchFilter
          key={key}
          value={filters.search ?? ''}
          changeFilters={changeFilters}
        />
      );

    return <></>;
  };

  return (
    <WbTableFilters onClear={resetFilters}>
      {templateKind?.userFilters?.map(filter => filterElement(filter))}
    </WbTableFilters>
  );
};
